import { useCurrentHousehold } from '@/hooks/useCurrentHousehold'
import { useEntitlement } from '@/hooks/useEntitlement'

/** True once useIsReadOnly's answer is final: the caller's role and the billing state have loaded. A form a
 *  link opens waits for it, so a viewer never sees it flash open while those load. */
export function useReadOnlyKnown(): boolean {
  const { role } = useCurrentHousehold()
  const entitlement = useEntitlement()
  return role !== null && !entitlement.isPending
}
